

$(".navbar-toggler").click(function(){

  $(".navbar-toggler").toggleClass("showtoggle");

});



$(".closed").click(function(){

  $(".navbar-collapse").removeClass("show");

});   


    $(".jobsbtn span").click(function(){
        $(".topjobbox").slideToggle("slow");
    });


    $(".searh_bx a").click(function(){
        $(".topjobbox").slideToggle("slow");
    });


$(window).scroll(function() {    
    var scroll = $(window).scrollTop();
    if (scroll >= 50) {
        $(".header_sec").addClass("fixed");

    } else {
        $(".header_sec").removeClass("fixed");
    }
   if (scroll >= 250) {
        $(".backTop").addClass("actv");

    } else {
        $(".backTop").removeClass("actv");
    } 
});

$('.logo-slider').owlCarousel({
    loop: true,
    margin: 0,
    autoplay: true,
    autoplayTimeout: 2000,
    autoplayHoverPause: true,
    smartSpeed: 800,
    dots: false,
    nav: false,
    responsive: {
        0: { items: 2 },
        600: { items: 3 },
        1000: { items: 5 }
    }
});



$(document).ready(function() {
var owl = $('.middle-banner.owl-carousel');
  owl.owlCarousel({
    margin:20,
    dots: false,
    autoplay: true,
    nav: true,
    dotsEach: false,
    loop: true,
     navText: [
                '<i class="fa-solid fa-arrow-left"></i>', // Icon for the previous button
                '<i class="fa-solid fa-arrow-right"></i>', // Icon for the next button
            ],
    responsive: {
      0: {	
        items: 1
      },
      1200: {
        items: 1
      }
    }
  });
});
$(document).ready(function() {
var owl = $('.meet-caro.owl-carousel');
  owl.owlCarousel({
    dots: false,
    autoplay: true,
    autoplayHoverPause: true,
    nav: true,
    navText: [
                '<i class="fa-solid fa-arrow-left"></i>', // Icon for the previous button
                '<i class="fa-solid fa-arrow-right"></i>', // Icon for the next button
            ],
    margin:20,
    dotsEach: false,
    stagePadding: 0,
    loop: true,
    responsive: {
      0: {	
        items: 1,
      },
      400: {	
        items: 1,
      },
      576: {	
        items:2,
      },
      768: {
        items: 2,
      },  
     1200: {
        items: 3
      }
    }
  });
});


document.addEventListener("DOMContentLoaded", function () {
const realSelect = document.getElementById("realSelect");
const customSelect = document.querySelector(".custom-select");
const selectBox = customSelect.querySelector(".select-box");
const optionsContainer = customSelect.querySelector(".options");

// IMPORTANT: correct selector
const valueText = customSelect.querySelector(".value");

// clear before adding (important if reload happens)
optionsContainer.innerHTML = "";

// create options
Array.from(realSelect.options).forEach(option => {
  const li = document.createElement("li");
  li.textContent = option.textContent;
  li.dataset.value = option.value;

  li.addEventListener("click", function () {
    valueText.innerText = this.innerText; // update UI
    realSelect.value = this.dataset.value; // sync select
    customSelect.classList.remove("active");
  });

  optionsContainer.appendChild(li);
});

// toggle
selectBox.addEventListener("click", function () {
  customSelect.classList.toggle("active");
});

// close outside
document.addEventListener("click", function (e) {
  if (!customSelect.contains(e.target)) {
    customSelect.classList.remove("active");
  }
});

});

